module.exports = __webpack_public_path__ + "img/7_uk.606fca83.svg";